let learnMore , privacyPolicy , policyTitle , policyDescription;
function onDocumentReady() {
    learnMore = $('#category-group-list .learn-more');
    privacyPolicy = $('.privacy-policy');
    policyTitle =  privacyPolicy.find('.policy-title');
    policyDescription =  privacyPolicy.find('.policy-description');

    learnMore.click(function() {
        let categoryDescription = $(this).closest('.category-list').find('.description');
        if(categoryDescription.hasClass('show-description')){
            $(this).removeClass('learn-more-active');
            categoryDescription.animate({height: "70px"}, 100).removeClass('show-description');
        }
        else{
            $(this).addClass('learn-more-active');
            categoryDescription.animate({
                height: categoryDescription.prop('scrollHeight')
            }, 100).addClass('show-description');
        }
    });

    policyTitle.click(function(){
        policyDescription.stop().slideToggle(200);
    });
}


$(onDocumentReady);



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/toggle-controller.js